<div class="notes">
  @if (invoice(); as invoiceData) {
    <div class="notes__mobile-title">
      {{ modalTitle() }}
    </div>

    <div class="notes__desktop-title">
      {{ modalTitleShort() }}
    </div>

    <div class="invoice-info">
      <div class="invoice-info__item invoice-info__item--desktop-only">
        <span class="invoice-info__label">{{
          'global.notes.invoice' | translate
        }}</span>
        <span class="invoice-info__value">{{ invoiceNumber() }}</span>
      </div>

      <div class="invoice-info__item">
        <span class="invoice-info__label">{{
          'global.notes.customer' | translate
        }}</span>
        <span class="invoice-info__value">{{
          invoiceData.cliente?.nombre
        }}</span>
      </div>

      <div class="invoice-info__item">
        <span class="invoice-info__label invoice-info__label--mobile">{{
          'global.notes.date' | translate
        }}</span>
        <span class="invoice-info__label invoice-info__label--desktop">{{
          'global.notes.issue-date' | translate
        }}</span>
        <span class="invoice-info__value">{{
          formatDate(invoiceData.invoiced_date)
        }}</span>
      </div>

      <div class="invoice-info__item">
        <span class="invoice-info__label">{{
          'global.notes.invoice-total' | translate
        }}</span>
        <span class="invoice-info__value">{{
          formatCurrency(invoiceData.venta[0]?.total)
        }}</span>
      </div>
    </div>

    <!-- Tabs -->
    <v-one-tabs
      [tabs]="tabs()"
      [activeTabId]="activeTabId()"
      (tabChange)="activeTabId.set($event)"
    ></v-one-tabs>
  } @else {
    <div class="loading">{{ 'Loading...' | translate }}</div>
  }
</div>

<ng-template #newNoteTab>
  @if (invoice(); as invoiceData) {
    <v-one-new-note
      [invoice]="invoiceData"
      [noteType]="noteType()"
      [totalAccredited]="totalAccredited()"
      [closeModal]="closeModal()"
    />
  }
</ng-template>

<ng-template #relatedNotesTab>
  <v-one-related-notes
    [invoiceId]="invoiceId()"
    [noteType]="noteType()"
    [relatedNotes]="relatedNotes()"
    [totalAccredited]="totalAccredited()"
  />
</ng-template>
